import {
  Backdrop,
  Button,
  Container,
  createStyles,
  Fade,
  makeStyles,
  Modal,
  Theme,
  Typography,
} from '@esure-cloud/react-components';
import { Data } from './documentsData';
import AISummaryFeedback from '../AISummaryFeedback';

export interface DocumentAiSummaryModalProps {
  buttonClicked: boolean;
  claimNumber: string;
  handleAiSummaryModalDisplay: () => void;
  modalDocumentData: Data;
}

const aiSummaryModalStyles = makeStyles((theme: Theme) =>
  createStyles({
    actionButton: {
      borderRadius: '8px',
      height: '48px',
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      width: '200px',
    },
    bold: {
      fontWeight: 800,
    },
    modal: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'center',
    },
    modalPaper: {
      backgroundColor: theme.palette.background.paper,
      border: '2px solid #000',
      borderRadius: '5px',
      boxShadow: theme.shadows[5],
      margin: '1rem',
      padding: theme.spacing(2, 4, 3),
    },
    wrapperModal: {
      [theme.breakpoints.down('sm')]: {
        height: '90vh',
      },
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      marginTop: '2rem',
      width: '100%',
    },
  }),
);

export const DocumentAiSummaryModal: React.FC<DocumentAiSummaryModalProps> = ({
  buttonClicked,
  claimNumber,
  handleAiSummaryModalDisplay,
  modalDocumentData,
}: DocumentAiSummaryModalProps) => {
  const classes = aiSummaryModalStyles();

  return (
    <Modal
      aria-labelledby="ai-summary-modal-title"
      aria-describedby="ai-summary-description"
      className={classes.modal}
      open={buttonClicked}
      onClose={handleAiSummaryModalDisplay}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={buttonClicked}>
        <Container maxWidth="lg" className={`${classes.modalPaper}`}>
          <Typography variant="h4" component="h4">
            AI Summary
          </Typography>
          <div className={classes.wrapperModal}>
            <table aria-label="ai summary">
              <thead>
                <tr>
                  <td style={{ overflowWrap: 'break-word', whiteSpace: 'normal', wordWrap: 'break-word' }}>
                    {modalDocumentData.aiSummary}
                  </td>
                  <td style={{ width: '10%' }}>
                    <AISummaryFeedback
                      claimNumber={claimNumber}
                      documentId={modalDocumentData.documentId.replaceAll(',', '')}
                    />
                  </td>
                </tr>
              </thead>
            </table>
          </div>
          <div>
            <div>
              <Button variant="contained" onClick={handleAiSummaryModalDisplay} className={classes.actionButton}>
                Close
              </Button>
            </div>
          </div>
        </Container>
      </Fade>
    </Modal>
  );
};
